// Utility functions for managing facility selection in localStorage

export interface Facility {
  id: number;
  name: string;
}

const FACILITY_STORAGE_KEY = 'selectedFacility';

export const saveFacilityToStorage = (facility: Facility | null): void => {
  try {
    if (facility) {
      localStorage.setItem(FACILITY_STORAGE_KEY, JSON.stringify(facility));
    } else {
      localStorage.removeItem(FACILITY_STORAGE_KEY);
    }
  } catch (error) {
    console.error('Failed to save facility to localStorage:', error);
  }
};

export const loadFacilityFromStorage = (): Facility | null => {
  try {
    const stored = localStorage.getItem(FACILITY_STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored) as Facility;
    }
  } catch (error) {
    console.error('Failed to load facility from localStorage:', error);
    // Clean up invalid data
    localStorage.removeItem(FACILITY_STORAGE_KEY);
  }
  return null;
};

export const clearFacilityFromStorage = (): void => {
  try {
    localStorage.removeItem(FACILITY_STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear facility from localStorage:', error);
  }
};

// Hook to get facility options formatted for react-select
export const formatFacilityOptions = (facilities: Facility[]) => {
  return facilities.map(f => ({ 
    value: f.id, 
    label: f.name,
    facility: f // Keep reference to full facility object
  }));
};

// Find facility by ID from options
export const findFacilityById = (facilities: Facility[], id: number): Facility | null => {
  return facilities.find(f => f.id === id) || null;
}; 